// extracted by mini-css-extract-plugin
export var btnNext = "partners-module--btnNext--FM1MV";
export var btnPrev = "partners-module--btnPrev--5Mb6w";
export var container = "partners-module--container--aYfEN";
export var head = "partners-module--head--bG4Cv";
export var root = "partners-module--root--U4mGp";
export var slide = "partners-module--slide--moalf";
export var swiper = "partners-module--swiper--0bVhv";
export var swiperOuter = "partners-module--swiperOuter--5vvMw";